export default class OfferLineItem {
  index: string = "";
  description: string = "";
  unit: string = "";
  amount: number = 0;
  unitPrice: number = 0;
  indexName: string = "";
  lineId: string = "";
  
  get netPrice(): number {
    return Number((this.amount * this.unitPrice).toFixed(2));
  }

  public constructor(init?: Partial<OfferLineItem>) {
    Object.assign(this, init);
  }
}
